import { Navigate, useParams } from "react-router-dom";

// Clean deep-link target for emails: /tasks/:taskId -> the all-tasks page,
// which auto-opens the task modal from the taskId query param.
export default function TaskRedirectPage() {
	const { taskId } = useParams();
	if (!taskId) return <Navigate to="/tasks" replace />;
	return <Navigate to={`/tasks?taskId=${taskId}`} replace />;
}
